export default __webpack_public_path__ + "static/media/okex.907bcabd.png";